import axios from 'axios';

export const getAllFbTracker = (token) => {
    let newURL = "/fbtracker/getall"
    return axios.get(`${newURL}`, {
        headers: { Authorization: token }
    });
};

export const creaditFbTracker = (data, token) => {
    let newURL = "/fbtracker/create"
    return axios.post(`${newURL}`, data, {
        headers: { Authorization: token }
    });
};

export const updateFbTracker = (id, target, data, token) => {
    let newURL = "/fbtracker/update/" + target + "/" +id
    return axios.patch(`${newURL}`, data, {
        headers: { Authorization: token }
    });
};